<div class="object-card-container placeholder-card" (click)="handleClick()">
  <div class="plus-sign">
    <fa-icon [icon]="['fas', 'plus']"></fa-icon>
  </div>
</div>
